<!-- 创建时间2022/01/26 10:37:57 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：多语言插槽组件 -->
<!-- 说明：{0} 代表默认插槽 {数字} === {slot数字} -->

<script>
import commonUtil from 'yxt-biz-pc/packages/common-util';
export const i18n = commonUtil.i18n;
// 处理字符串的数字插槽，转化成字符串插槽 数字0插槽为默认插槽
const handleText = (props) => {
  let text = props.text || i18n.t(props.langKey);
  let reg = /\{(.+?)\}/gi;
  // 需要插槽的{name}的List
  let matchList = text.match(reg) || [];
  console.log(matchList);
  for (let i = 0; i < matchList.length; i++) {
    const name = matchList[i].replace('{', '').replace('}', '');
    if (!isNaN(name)) {
      if (name === '0') {
        text = text.replace(matchList[i], '{default}');
      } else {
        text = text.replace(matchList[i], `{slot${name}}`);
      }
    }
  }
  return text;
};
export default {
  name: 'language-slot',
  functional: true,
  props: {
    text: { // 多语言对应的文案
      type: String,
      default: ''
    },
    langKey: { // 多语言key
      type: String,
      default: ''
    },
    className: { // class类名
      type: String,
      default: ''
    }
  },
  render(createElement, context) {
    console.log(createElement);
    console.log(context);
    const _this = context;
    let text = handleText(_this.props);
    let reg = /\{(.+?)\}/gi;
    // 需要插槽的{name}的List
    let matchList = text.match(reg) || [];
    let splitStr = matchList.join('|');
    // 文字数组
    const textArray = text.split(RegExp(splitStr)) || [];
    let elList = [];
    for (let i = 0; i < textArray.length; i++) {
      elList.push(textArray[i]);
      if (i < matchList.length) {
        const name = matchList[i].replace('{', '').replace('}', '');
        if (_this.scopedSlots && _this.scopedSlots[name]) {
          elList.push(_this.scopedSlots[name]());
        }
      }
    }
    const wrap = createElement('div', { attrs: { class: 'survey-language-slot ' + _this.props.className } }, elList);
    console.log(wrap);
    return wrap;
  }
};
</script>
